class TableUtilities {
  generatePaginateMetadata = (currentSearchPagination, currentPage, create = false, itemsPerPage = 10) => {
    if (create) {
      currentSearchPagination.totalCount += 1;
      currentSearchPagination.totalPages = Math.ceil(
        currentSearchPagination.totalCount / itemsPerPage
      );
    }
  
    return {
      ...currentSearchPagination,
      currentPage,
      nextPage: currentPage === currentSearchPagination.totalPages ? 0 : currentPage + 1,
      prevPage: currentPage === 1 ? 0 : currentPage - 1,
    };
  };

  sortAreas = (a, b) => {
    let area_id_a = a.parentId;
    let area_id_b = b.parentId;
    let name_a = a.name.toLowerCase()
    let name_b = b.name.toLowerCase()
    
    if (area_id_a !== null && area_id_b === null) return 1
    if (area_id_a === null && area_id_b !== null) return -1
    
    if (name_a > name_b) return 1
    if (name_a < name_b) return -1
    return 0;
  }
}


export default new TableUtilities();
